import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Result, Space } from '@arco-design/web-react';
import { logout as logoutApi } from '@/services/auth';
import { clearAuthMarkerCookie } from '@/utils/authSession';
import { PROFILE_PATH } from '@/routes';
import styles from './style.module.less';

export default function ForbiddenPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('error.forbidden.title')} - LetsFly`;
  }, [t]);

  const handleLogout = async () => {
    try {
      await logoutApi();
    } catch {
      // ignore
    } finally {
      dispatch({ type: 'update-user', payload: { user: null } });
      clearAuthMarkerCookie();
      navigate('/login');
    }
  };

  return (
    <div className={styles.container}>
      <Result
        status="403"
        title={t('error.forbidden.title')}
        subTitle={t('error.forbidden.subtitle')}
        extra={
          <Space>
            <Button type="primary" onClick={() => navigate(PROFILE_PATH)}>
              {t('nav.profile')}
            </Button>
            <Button onClick={() => void handleLogout()}>{t('nav.logout')}</Button>
          </Space>
        }
      />
    </div>
  );
}
